import React from 'react';

const Process = () => {
    return (
        <section id="process" className="section-padding-lg bg-primary lg:min-h-screen flex flex-col justify-center overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10" data-aos="fade-up">
                    <h2 className="label-md mb-3">Onboarding</h2>
                    <h3 className="heading-lg">
                        The Trustpoint Process
                    </h3>
                    <p className="paragraph-lg mt-4">
                        A seamless, three-step journey to reclaim your time and confidence in your finances.
                    </p>
                </div>

                <div className="relative max-w-3xl mx-auto">
                    <div className="absolute top-12 bottom-12 left-6 sm:left-8 w-0.5 bg-gray-200 hidden sm:block" aria-hidden="true"></div>

                    <div className="space-y-10 sm:space-y-6 relative z-10">
                        <div className="relative flex flex-col sm:flex-row items-center sm:items-center group" data-aos="fade-up" data-aos-delay="100">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 flex-shrink-0 bg-primary-light border border-gray-100 rounded-full flex items-center justify-center relative z-10 mb-4 sm:mb-0 sm:mr-8 transition-colors duration-300">
                                <span className="text-xl sm:text-2xl font-light text-secondary">1</span>
                            </div>
                            <div className="bg-primary-light p-6 sm:p-8 rounded-2xl border border-gray-100 hover-lift text-center sm:text-left w-full sm:flex-1">
                                <h4 className="heading-md mb-2 sm:mb-3">Initial Inquiry</h4>
                                <p className="paragraph-md text-sm sm:text-base">
                                    Email us today. A team member will schedule a meeting to understand your practice and gather
                                    the necessary information for our audit.
                                </p>
                            </div>
                        </div>

                        <div className="relative flex flex-col sm:flex-row items-center sm:items-center group" data-aos="fade-up" data-aos-delay="200">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 flex-shrink-0 bg-primary-light border border-gray-100 rounded-full flex items-center justify-center relative z-10 mb-4 sm:mb-0 sm:mr-8 transition-colors duration-300">
                                <span className="text-xl sm:text-2xl font-light text-secondary">2</span>
                            </div>
                            <div className="bg-primary-light p-6 sm:p-8 rounded-2xl border border-gray-100 hover-lift text-center sm:text-left w-full sm:flex-1">
                                <h4 className="heading-md mb-2 sm:mb-3">Free Financial Audit</h4>
                                <p className="paragraph-md text-sm sm:text-base">
                                    Over 2 weeks, our specialized team reviews your current RCM setup, claim status, and revenue
                                    history to create a comprehensive report.
                                </p>
                            </div>
                        </div>

                        <div className="relative flex flex-col sm:flex-row items-center sm:items-center group" data-aos="fade-up" data-aos-delay="300">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 flex-shrink-0 bg-primary-light border border-gray-100 rounded-full flex items-center justify-center relative z-10 mb-4 sm:mb-0 sm:mr-8 transition-colors duration-300">
                                <span className="text-xl sm:text-2xl font-light text-secondary">3</span>
                            </div>
                            <div className="bg-primary-light p-6 sm:p-8 rounded-2xl border border-gray-100 hover-lift text-center sm:text-left w-full sm:flex-1">
                                <h4 className="heading-md mb-2 sm:mb-3">Report Review</h4>
                                <p className="paragraph-md text-sm sm:text-base">
                                    We provide a clear, actionable plan to eliminate "black holes" in your revenue. Get a
                                    definitive path to scale confidently.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 sm:mt-10 text-center">
                        <a href="#contact" className="btn-primary-lg">
                            Start Step 1 Now
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Process;
